module.exports = __webpack_public_path__ + "static/img/3.2fc06808.jpg";